import { Button } from '@repo/shadcn';
import { FC } from 'react';
import { z } from 'zod';

import { IwForm } from '@components/form';
import { TextField } from '@components/form/fields';
import { SectionTitle } from '@components/ui';

const GenericFormSchema = z.object({
    name: z.string().min(1, 'Name is required'),
});

export type TGenericForm = z.infer<typeof GenericFormSchema>;

type GenericFormProps = {
    initialValues: TGenericForm;
    onSubmit?: (data: TGenericForm) => Promise<void>;
    isLoading?: boolean;
    title?: string;
};

export const GenericForm: FC<GenericFormProps> = ({
    initialValues,
    onSubmit,
    isLoading = false,
    title = 'Generic Form',
}) => {
    return (
        <div>
            <SectionTitle>{title}</SectionTitle>
            <IwForm
                schema={GenericFormSchema}
                initialValues={initialValues}
                onSubmit={onSubmit as any}
            >
                <div className={'flex flex-col space-y-4'}>
                    <TextField<TGenericForm>
                        name={'name'}
                        label={'Name'}
                        placeholder={'Enter generic name'}
                    />

                    <div className={''}>
                        <Button type={'submit'} disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                    </div>
                </div>
            </IwForm>
        </div>
    );
};

GenericForm.displayName = 'GenericForm';
